export function exportToCsv(state, hatmId) {
  const headers = ['"Cüz No"', '"Okuyan"', '"Durum"'];
  const csvContent = [
    `"Hatim Başlığı","${state.title}"`,
    `"Oluşturan","${state.creatorName}"`,
    `"Oluşturulma Tarihi","${new Date(state.date).toLocaleDateString('tr-TR')}"`,
    `"Bitiş Tarihi","${new Date(state.endDate).toLocaleDateString('tr-TR')}"`,
    '',
    headers.join(',')
  ];

  for (let i = 1; i <= 30; i++) {
    const juzData = state.juzs[i];
    const row = [
      `"${i}"`,
      `"${juzData ? juzData.fullName : '-'}"`,
      `"${juzData ? 'Alındı' : 'Boş'}"`
    ];
    csvContent.push(row.join(','));
  }

  const BOM = '\uFEFF';
  const csvString = BOM + csvContent.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
  
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  const sanitizedTitle = state.title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  const currentTime = new Date().toLocaleString('tr-TR').replace(/[/\s:]/g, '-');
  link.download = `hatmedecem.com_${sanitizedTitle}_${hatmId}_${currentTime}.csv`;
  link.click();
} 